import { trackEvent } from '@pb/utils'

export const trackOmniJoinInitiate = (): any => {
  const trackingData = {
    event_category: 'Club',
    event_type: 'OMNI_JOIN_INITIATE',
    event_id: 'Join OMNI credit initiated',
    event_label: 'H&M x Klarna',
  }

  trackEvent(trackingData)
}

export const trackOmniJoinSuccess = (): any => {
  const trackingData = {
    event_category: 'Club',
    event_type: 'OMNI_JOIN_SUCCESS',
    event_id: 'Join OMNI credit succeeded',
    event_label: 'H&M x Klarna',
  }

  trackEvent(trackingData)
}

export const trackOmniJoinTechnicalError = (): any => {
  const trackingData = {
    event_category: 'Club',
    event_type: 'OMNI_JOIN_ERROR',
    event_id: 'Join OMNI credit unsuccessful',
    event_label: 'Technical error',
  }

  trackEvent(trackingData)
}

export const trackOmniJoinKlarnaAuthDeclined = (): any => {
  const trackingData = {
    event_category: 'Club',
    event_type: 'OMNI_JOIN_ERROR',
    event_id: 'Join OMNI credit unsuccessful',
    event_label: 'Auth-declined error',
  }

  trackEvent(trackingData)
}
